import { render, staticRenderFns } from "./OnBoardRequestsList.vue?vue&type=template&id=165008ee&scoped=true&"
import script from "./OnBoardRequestsList.vue?vue&type=script&lang=js&"
export * from "./OnBoardRequestsList.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardRequestsList.vue?vue&type=style&index=0&id=165008ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165008ee",
  null
  
)

export default component.exports